import { render, staticRenderFns } from "./DisciplineInformation.vue?vue&type=template&id=4845a1f4&"
import script from "./DisciplineInformation.vue?vue&type=script&lang=js&"
export * from "./DisciplineInformation.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineInformation.vue?vue&type=style&index=0&id=4845a1f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports